/*eslint no-useless-constructor: "error"*/
"use strict";
export class NewsModel {
  constructor(json) {
    this.init();
    if (json) {
      this.initWithJson(json);
    }
  }
  init() {
    this.newsId = null
    this.title =
      "主題書展-毛起來讀BAR!9/1(三)-10/31(日)｜新營文化中心3F開架閱覽室...";
    this.newsContent =
      "你知道嗎?因為人口結構的改變，今年全台「毛小孩」數量已經大於「小小孩」了呢! 毛孩子已成為你我密不可分的家人、同伴…\n" +
      "本次精選動物主題相關書展，不管你是貓派還是汪派…都一起毛起來讀BAR!";
    this.createTime = null
    this.updateTime = null
    this.status = null
    this.isOpened = false;
  }
  initWithJson(json) {
    this.newsId = json["newsId"];
    this.title = json["title"];
    this.newsContent = json["newsContent"];
    this.createTime = json["createTime"];
    this.updateTime = json["updateTime"];
    this.status = json["status"];
    this.isOpened = json["isOpened"];
  }
}
